/* Xokool custom scripts */

/* Move the Jotly "Size Chart" app block into the Size variant label (Size: S | Size Chart) */
(function () {
  function moveSizeChart() {
    var btn = document.getElementById('jsc-trigger-button');
    if (!btn) return;
    var block = btn.closest('.shopify-app-block') || btn;
    var legend = document.querySelector('.hdt-product__variant-picker fieldset.is-style-size legend.hdt-product-form__label');
    if (!legend || legend.contains(block)) return;
    block.classList.add('xk-size-chart-inline');
    legend.appendChild(block);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveSizeChart);
  } else {
    moveSizeChart();
  }
})();

/* Loox lives inside the REVIEWS accordion item: it lays itself out while the
   <details> is closed (width 0), so nudge it with a resize event on open */
(function () {
  function bind() {
    document.querySelectorAll('.hdt-product-accordion__item').forEach(function (details) {
      if (!details.querySelector('#looxReviews')) return;
      details.querySelector('summary').addEventListener('click', function () {
        setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 350);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

/* Clicking the "Guaranteed secure & safe checkout" box scrolls to the
   PAYMENT METHODS accordion tab and opens it */
(function () {
  function bind() {
    var box = document.querySelector('.xk-trust-boxed');
    if (!box) return;
    box.style.cursor = 'pointer';
    box.addEventListener('click', function () {
      var items = document.querySelectorAll('.hdt-product-accordion__item');
      for (var i = 0; i < items.length; i++) {
        var t = items[i].querySelector('.hdt-product-accordion__text');
        if (t && /payment\s*methods/i.test(t.textContent)) {
          if (items[i].hasAttribute('open')) {
            items[i].querySelector('summary').click();
          } else {
            items[i].querySelector('summary').click();
            items[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          break;
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

/* Clicking the Loox star rating under the product title should open the
   REVIEWS accordion tab and scroll to it. Loox's own click handler (document
   capture) scrolls to the closed <details> position, mid-page — so we listen
   on window capture (fires first) and block it. The product-info column is
   sticky, so a single scrollIntoView undershoots; iterate until it lands. */
(function () {
  window.addEventListener('click', function (e) {
    var rating = e.target.closest ? e.target.closest('.loox-rating') : null;
    if (!rating) return;
    if (rating.closest('.hdt-product-accordion__item')) return; /* rating inside the widget itself */
    var items = document.querySelectorAll('.hdt-product-accordion__item');
    for (var i = 0; i < items.length; i++) {
      if (!items[i].querySelector('#looxReviews')) continue;
      e.preventDefault();
      e.stopImmediatePropagation();
      var item = items[i];
      if (!item.hasAttribute('open')) item.querySelector('summary').click();
      var n = 0;
      var step = function () {
        var t = item.getBoundingClientRect().top;
        if (Math.abs(t) < 30 || n >= 6) return;
        n++;
        item.scrollIntoView({ behavior: 'instant', block: 'start' });
        setTimeout(step, 120);
      };
      setTimeout(step, 450);
      break;
    }
  }, true);
})();

/* Count badges: hide while the count is 0 (toolbar + header) */
(function () {
  var sel = '.hdt-toolbar__count-box, .hdt-site-top_nav .hdt-count-box';
  function applyAll() {
    document.querySelectorAll(sel).forEach(function (el) {
      el.classList.toggle('xk-badge-zero', el.textContent.trim() === '0');
    });
  }
  function bind() {
    applyAll();
    var mo = new MutationObserver(applyAll);
    document.querySelectorAll(sel).forEach(function (el) {
      mo.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();

/* Mobile PDP: the sticky ATC is visible by default via CSS from first paint.
   Here we only add .xk-atc-off while the real buy button is on screen, so the
   bar ducks away when it would duplicate the visible button. */
(function () {
  function bind() {
    if (!window.matchMedia('(max-width: 1024px)').matches) return;
    var sticky = document.querySelector('.hdt-sticky-btn-atc');
    var btn = document.querySelector('.hdt-product-form__submit:not(.hdt-sticky-atc__submit)');
    if (!sticky || !btn || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      document.body.classList.toggle('xk-atc-off', entries[0].isIntersecting);
    });
    io.observe(btn);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();

/* XK: account sign-in popup (<shopify-account>) slides in/out like the cart drawer:
   from the right on desktop, from the left under the header on phones (CSS in xokool-custom.css).
   Shopify's component removes the dialog ~200ms after .closing is added, so the exit slide stays under that. */
(function () {
  var phone = window.matchMedia('(max-width: 767px)');
  function frames(dir, out) {
    var off = 'translateX(' + dir + '100%)';
    return out ? [{ transform: 'translateX(0)' }, { transform: off }] : [{ transform: off }, { transform: 'translateX(0)' }];
  }
  function fade(dl, from, to, ms) {
    try { dl.animate([{ opacity: from }, { opacity: to }], { duration: ms, pseudoElement: '::backdrop', fill: 'forwards' }); } catch (e) {}
  }
  /* phones: put the drawer right under the sticky header, measured now (it moves with the top bar / scroll) */
  function placeUnderHeader() {
    var st = document.getElementById('xk-acc-style');
    if (!phone.matches) { if (st) st.textContent = ''; return; }
    var hdr = document.querySelector('hdt-sticky-header');
    var top = hdr ? Math.max(Math.round(hdr.getBoundingClientRect().bottom), 0) : 0;
    if (!st) { st = document.createElement('style'); st.id = 'xk-acc-style'; document.head.appendChild(st); }
    st.textContent = '@media (max-width: 767px){shopify-account::part(dialog){top:' + top + 'px;height:calc(100dvh - ' + top +
      'px);max-height:calc(100dvh - ' + top + 'px)}shopify-account::part(dialog)::backdrop{top:' + top + 'px}}';
  }
  /* top strip like the cart drawer's (grey 36px bar, 12px uppercase title, the shared thin X);
     the header lives in the component's shadow DOM, so the style goes in there */
  var X_ICON = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M2 2L14 14M14 2L2 14' stroke='%23111' stroke-width='1.75' stroke-linecap='round'/%3E%3C/svg%3E\")";
  var STRIP_CSS =
    '.account__header{display:flex!important;align-items:center!important;justify-content:space-between!important;' +
    'height:36px!important;min-height:36px!important;padding:0 4px 0 16px!important;box-sizing:border-box!important;background:#f5f5f5!important}' +
    '.account__header-content{padding:0!important}' +
    '.account__heading{font-size:12px!important;font-weight:400!important;line-height:16.2px!important;letter-spacing:normal!important;' +
    'text-transform:uppercase!important;color:#000!important}' +
    '.account__close{width:40px!important;height:40px!important;min-width:40px!important;padding:0!important;border-radius:50%!important;' +
    'background:transparent ' + X_ICON + ' center/16px 16px no-repeat!important}' +
    '.account__close svg{display:none!important}' +
    '.account__content{margin-top:0!important;padding-top:20px!important}' +
    /* only the content scrolls: with always-visible scrollbars the outer .account showed a scrollbar
       column next to the X (white sliver between the X and the edge); the 40px X no longer overflows the 36px strip */
    '.account{overflow:hidden!important;max-height:none!important;height:100%!important}.account__close{margin:-2px 0!important}' +
    /* extra content from snippets/xk-account-extra.liquid (benefits, quick links, rating) */
    '.xk-acc{margin-top:24px;padding-top:20px;border-top:1px solid #e6e6e6;color:#111}' +
    '.xk-acc__h{margin:0 0 12px;font-size:12px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#666}' +
    '.xk-acc__list{list-style:none;margin:0 0 22px;padding:0;display:grid;gap:10px}' +
    '.xk-acc__list li{display:flex;gap:10px;align-items:flex-start;font-size:14px;line-height:1.4}' +
    '.xk-acc__list svg{flex:0 0 16px;width:16px;height:16px;margin-top:2px;color:#00249c}' +
    '.xk-acc__links{display:block;border-top:1px solid #e6e6e6}' +
    '.xk-acc__links a{display:flex;align-items:center;justify-content:space-between;padding:13px 2px;border-bottom:1px solid #e6e6e6;' +
    'color:#111;text-decoration:none;font-size:14px}' +
    '.xk-acc__links a:hover{color:#00249c}.xk-acc__links svg{width:14px;height:14px;color:#888}' +
    '.xk-acc__rating{display:flex;align-items:center;justify-content:center;gap:6px;margin-top:20px;font-size:13px;color:#111;text-decoration:none}' +
    '.xk-acc__stars{letter-spacing:1px;color:#111}' +
    /* signed in: the email line would overflow the 36px strip, so it is shown in the content instead */
    '.account__header-content--has-email .account__email{display:none!important}' +
    '.xk-acc__who{margin:0 0 16px;font-size:14px;line-height:1.4;color:#666;overflow-wrap:anywhere}';
  /* copy the theme's <template id="xk-acc-extra"> into the drawer and swap the strip title; Shopify re-renders
     the drawer's content when it changes step (e.g. "More ways to sign in"), so this re-runs on every change */
  function fillExtra(sr) {
    var tpl = document.getElementById('xk-acc-extra');
    if (!tpl) return;
    var title = tpl.getAttribute('data-title');
    var h = sr.querySelector('.account__heading');
    /* signed in (Shopify adds --has-email): keep Shopify's own heading, and move the email out of the 36px strip
       into the top of the content, where it has room (XK 03.11.2026) */
    var signedIn = !!sr.querySelector('.account__header-content--has-email');
    if (h && !h.hasAttribute('data-xk-orig') && h.textContent !== title) h.setAttribute('data-xk-orig', h.textContent);
    if (signedIn) {
      var orig = h && h.getAttribute('data-xk-orig');
      if (h && orig && h.textContent !== orig) h.textContent = orig;
    } else if (title && h && h.textContent !== title) h.textContent = title;
    var box = sr.querySelector('.account__content');
    var em = sr.querySelector('.account__email');
    if (box && signedIn && em && !box.querySelector('.xk-acc__who')) {
      var who = document.createElement('p');
      who.className = 'xk-acc__who';
      who.textContent = em.textContent;
      box.insertBefore(who, box.firstChild);
    }
    if (box && !box.querySelector('.xk-acc')) box.appendChild(tpl.content.cloneNode(true));
  }
  function hook(acc) {
    var sr = acc.shadowRoot;
    var dl = sr && sr.querySelector('dialog');
    if (!dl || dl.xkHooked) return;
    dl.xkHooked = true;
    var st = document.createElement('style');
    st.textContent = STRIP_CSS;
    sr.appendChild(st);
    fillExtra(sr);
    var filling = false;
    new MutationObserver(function () {
      if (filling) return;
      filling = true;
      fillExtra(sr);
      filling = false;
    }).observe(sr, { childList: true, subtree: true, characterData: true });
    var anim;
    new MutationObserver(function () {
      var closing = dl.classList.contains('closing');
      var dir = phone.matches ? '-' : '';
      if (dl.open && !closing && !dl.xkShown) {
        dl.xkShown = true;
        placeUnderHeader();
        /* Shopify keeps scrollbar-gutter:stable on <html> while it is open, which paints a blank
           scrollbar-wide strip over the drawer's right edge; the cart's lock doesn't, so match it */
        document.documentElement.style.setProperty('scrollbar-gutter', 'auto', 'important');
        lockPage(dl);
        if (anim) anim.cancel();
        anim = dl.animate(frames(dir, false), { duration: 350, easing: 'cubic-bezier(.32,.72,0,1)' });
        fade(dl, 0, 1, 350);
      } else if (closing && dl.xkShown) {
        dl.xkShown = false;
        if (anim) anim.cancel();
        anim = dl.animate(frames(dir, true), { duration: 190, easing: 'ease-in', fill: 'forwards' });
        fade(dl, 1, 0, 190);
      } else if (!dl.open) {
        dl.xkShown = false;
        document.documentElement.style.removeProperty('scrollbar-gutter');
        unlockPage(dl);
      }
    }).observe(dl, { attributes: true, attributeFilter: ['open', 'class'] });
  }
  /* country picker: lock the page like the cart drawer (html[scroll-lock]) so the page scrollbar
     doesn't sit over the drawer's right edge next to the X */
  function hookPicker() {
    var cc = document.getElementById('popover-currencies');
    if (!cc || cc.xkHooked) return;
    cc.xkHooked = true;
    var html = document.documentElement;
    new MutationObserver(function () {
      if (cc.open && !html.hasAttribute('scroll-lock')) { html.setAttribute('scroll-lock', ''); cc.xkLocked = true; }
      else if (!cc.open && cc.xkLocked) { html.removeAttribute('scroll-lock'); cc.xkLocked = false; }
    }).observe(cc, { attributes: true, attributeFilter: ['open'] });
  }
  /* lock the page the theme's way (html[scroll-lock], like the cart): removing the scrollbar on its own
     made the page 1 scrollbar wider for a moment, so the hero image jumped — read as a zoom-in.
     Set already on the tap, before the popup opens, so there is no frame without the compensation. */
  var accLock = null;
  function lockPage(owner) {
    var html = document.documentElement;
    if (html.hasAttribute('scroll-lock')) return;
    html.setAttribute('scroll-lock', '');
    accLock = owner;
  }
  function unlockPage(owner) {
    if (accLock && accLock === owner) { document.documentElement.removeAttribute('scroll-lock'); accLock = null; }
  }
  function scan() { document.querySelectorAll('shopify-account').forEach(hook); hookPicker(); }
  scan();
  document.addEventListener('pointerdown', function (e) {
    scan();
    placeUnderHeader();
    var acc = e.composedPath().filter(function (n) { return n.tagName === 'SHOPIFY-ACCOUNT'; })[0];
    var dl = acc && acc.shadowRoot && acc.shadowRoot.querySelector('dialog');
    if (dl && !dl.open && e.composedPath()[0] && !(dl.contains(e.composedPath()[0]))) {
      lockPage(dl);
      /* the tap didn't open it after all: give the page back */
      setTimeout(function () { if (!dl.open) unlockPage(dl); }, 1500);
    }
  }, true);
  window.addEventListener('load', scan);
})();
